import { render } from "./level-with-indicator.vue?vue&type=template&id=23bf6b8c&ts=true"
import script from "./level-with-indicator.ts?vue&type=script&lang=ts&external"
export * from "./level-with-indicator.ts?vue&type=script&lang=ts&external"

import "./level-with-indicator.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__